import * as React from "react";
import { QESButton } from "@app/shared/qes-standards";
import { ClientInsuranceModel } from "./models";

interface InsuranceListProps {
  disabled?: boolean;
  handleRemoveInspectedInsurance: (insuranceUid: string) => void;
  selectedInsurances: ClientInsuranceModel[];
}

export const InsuranceList: React.FC<React.PropsWithChildren<InsuranceListProps>> = (props: InsuranceListProps) => {
  if (props.selectedInsurances.length < 1) {
    return null;
  }

  return (
    <ol className="container p-0">
      {props.selectedInsurances.map((ins) => {
        const baseClassName = "col-12 d-inline-flex justify-content-between p-2 pr-0 border-top align-items-center";
        const className = ins.active ? baseClassName : `${baseClassName} alert-danger`;
        const displayName = `${ins.planName}: ${ins.uid}${ins.active ? "" : " - Deactivated. Please remove"}`;
        return (
          <li key={ins.uid} className={className}>
            <span>{displayName}</span>
            <QESButton qesType="secondary" qesTestId={`delete-insurance-${ins.uid}`} onClick={() => props.handleRemoveInspectedInsurance(ins.uid)} disabled={props.disabled}><i className="fa fa-times" /></QESButton>
          </li>
        );
      })}
    </ol>
  );
}